import { returnArrayOrNull, returnStringOrNull } from '@surf-turf/nemo/assets/utils-type-check'

/**
 * Get value from url.
 *
 * @param {string} optionName
 *
 * @returns {string}
 */
export const getValueFromUrl = (optionName) => {
  const allSearchParameters = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  return returnStringOrNull(decodeURI(allSearchParameters[optionName]))
}

/**
 * Get all values and names from url.
 *
 * @param {string} optionName
 *
 * @returns {string}
 */
export const getAllValuesAndNamesFromUrl = () => {
  const allSearchParameters = new URLSearchParams(window.location.search)
  const finalArray = []

  for (const param of allSearchParameters) {
    if (param[0] == 'size' || param[0] == 'color' || param[0] == 'pairing' || param[0] == 'connectedProductsize1' || param[0] == 'connectedProductsize2' || param[0] == 'denominations') {
      finalArray.push({
        name: param[0],
        value: decodeURI(param[1]),
      })
    }
  }

  return returnArrayOrNull(finalArray)
}

/**
 * Set value in url.
 *
 * @param {string} value
 * @param {string} searchValue
 */
export const setValueInUrl = (value, searchValue) => {
  const url = new URL(window.location)
  const urlSafeValue = encodeURI(value)

  // Set search parameters in the url
  url.searchParams.set(searchValue, urlSafeValue)

  // Push window history with the new url parameters
  window.history.pushState({}, '', url)
}
